<div class="modal-body identification-box modal-allow-overflow m-0 m-lg-3 overflow-auto">
    
    <div class="row row-cols-12 mb-2">
        <div class="fw-bolder col-12 text-truncate">            
            <span class="badge bg-primary perform-action-dialog-header-badgenumber rounded-pill me-2">
                <span class="align-middle text-white">{{expectedActionNumber}}</span>
            </span>            
            <span>{{requestName}}</span>
        </div>
    </div> 

    <app-performactioncertificateprovider *ngIf="this.user.isCustomer" [signatureProvider]="signatureProvider"
        [signatureProviderName]="signatureProviderName" [signatureProviders]="signatureProviders"
        (newSignMethod)="getNewSignMethod($event)"></app-performactioncertificateprovider>

    <app-user-identification-details *ngIf="eSeal"></app-user-identification-details>

    <div class="card">
        <div class="card-header">
            <nav ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav nav-tabs card-header-tabs">
                <ng-container *ngIf="showStamp" ngbNavItem="DigitalStamp">
                    <a ngbNavLink>
                        <span translate="Tabs.Stamp"></span>
                    </a>
                    <ng-template class="tabcontent-height" ngbNavContent>
                        <div class="uploadedSigningImageNavContent d-table-cell align-middle">
                            <img [src]="stampImage" alt="{{'Request.View.SigningDialog.AltStamp' | translate}}"
                                class="stamp-image" />
                        </div>
                    </ng-template>
                </ng-container>
                <ng-container *ngIf="showDraw" ngbNavItem="MouseOrTouch">
                    <a ngbNavLink (click)="getScribble();">
                        <span translate="Tabs.Draw"></span>
                    </a>
                    <ng-template ngbNavContent>
                        <button class="mt-2 clearScribble-button z-index-signaturepad-clear"
                            [ngClass]="{'d-none' : signaturePad?.isEmpty()}" (click)="clearScribble()">
                            <i class="bi bi-x bi-large"></i>
                        </button>
                        <div class="w-100 cnvSignature">
                            <div class="d-flex dashed-line-bottom">
                                <span id="SignatureInfo"
                                    class="position-absolute top-50 start-50 text-muted w-50 translate-middle z-index-signaturepad-info"
                                    translate="Dialog.UseMouseOrTouchscreen"></span>
                                <signature-pad #signature (drawStart)="drawStart($event)"
                                    class="bg-transparent z-index-signaturepad"
                                    [options]="signaturePadOptions"></signature-pad>
                            </div>
                            <div class="mt-2 mb-2 d-table w-100">
                                <div class="float-none form-check form-switch ps-1">
                                    <input class="switch-form-default float-end me-3 form-check-input items"
                                        type="checkbox" role="switch" [(ngModel)]="scribbleText"
                                        (change)="setTextInScribbleImageWhenSwitchedChecked()">
                                </div>
                                <span class="ms-2" translate="Button.ShowNameAndDateInSignature"></span>
                            </div>
                        </div>
                    </ng-template>
                </ng-container>
                <ng-container *ngIf="showPicture" ngbNavItem="UploadPicture">
                    <a ngbNavLink (click)="getUploadedImageWhenPicureTabIsActive();">
                        <span translate="Tabs.Picture"></span>
                    </a>
                    <ng-template ngbNavContent>
                        <div class="d-block position-relative">
                            <div class="uploadContent position-relative dashed-line-bottom">
                                <div *ngIf="!signatureUploaded" class="z-index-signaturepad-clear">
                                    <input type="file" class="file-input d-none" (change)="uploadSigningImage($event)"
                                        #fileUpload>
                                    <button class="btn btn-sm btn-primary uploadSignature z-index-signaturepad-browse"
                                        [ngClass]="{'d-none' : signatureUploaded}" type="button" id="dropdownMenu"
                                        (click)="fileUpload.click()"><span
                                            translate="Button.ChooseFile"></span></button>
                                </div>
                                <div *ngIf="signatureUploaded">
                                    <button class="mt-2 clearScribble-button z-index-signaturepad-clear"
                                        [ngClass]="{'d-none' : !signatureUploaded}" (click)="removeUploadedImage()">
                                        <i class="bi bi-x bi-large"></i>
                                    </button>
                                    <canvas id="signatureImageCanvas" [width]="canvasWidth"
                                        [height]="canvasHeight"></canvas>
                                </div>
                            </div>
                            <div class="mt-2 mb-2 d-table w-100">
                                <div class="float-none form-check form-switch ps-1">
                                    <input class="switch-form-default float-end form-check-input items" type="checkbox"
                                        role="switch" [(ngModel)]="scribbleText"
                                        (change)="setTextInScribbleImageWhenSwitchedChecked()">
                                </div>
                                <span class="ms-2" translate="Button.ShowNameAndDateInSignature"></span>
                            </div>
                        </div>
                    </ng-template>
                </ng-container>
            </nav>
        </div>
        <div [ngbNavOutlet]="nav"></div>
    </div>

    <form [formGroup]="form">
        <div class="input-group mt-3" *ngIf="user && user.isCustomer && showReason">
            <input type="text" class="form-control form-control-sm" id="reason" name="reason" formControlName="reason"
                (keyup)="fieldChange('reason',$event)" (focusout)="fieldChange('reason',$event)"
                placeholder="{{ 'Dialog.ReasonPlaceholder' | translate }}">
            <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"
                aria-expanded="false" translate="Button.Choose"></button>
            <ul class="dropdown-menu dropdown-menu-end" style="z-index: 9999;">
                <li *ngFor="let reason of reasons"><a class="dropdown-item"
                        (click)="setReason(reason.reason)">{{reason.reason}}</a></li>
            </ul>
            <div class="d-block w-100 invalid-feedback" *ngIf="form.controls['reason'].errors?.['pattern']"
                translate="Error.FieldInvalid"></div>
        </div>

        <div class="input-group mt-2 mb-0" *ngIf="user && user.isCustomer && showLocation">
            <input type="text" class="form-control form-control-sm" id="location" name="location"
                formControlName="location" (keyup)="fieldChange('location',$event)"
                (focusout)="fieldChange('location',$event)"
                placeholder="{{ 'Dialog.LocationPlaceholder' | translate }}">
            <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"
                aria-expanded="false" translate="Button.Choose"></button>
            <ul class="dropdown-menu dropdown-menu-end" style="z-index: 9999;">
                <li *ngFor="let location of locations"><a class="dropdown-item"
                        (click)="setLocation(location.location)">{{location.location}}</a></li>
            </ul>
            <div class="d-block w-100 invalid-feedback" *ngIf="form.controls['location'].errors?.['pattern']"
                translate="Error.FieldInvalid"></div>
        </div>
    </form>

    <div class="mt-4 d-table w-100">
        <span class="float-start">
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="back();"
                translate="Button.Back"></button>
        </span>
        <span class="float-end">
            <button type="button" class="btn btn-sm btn-success ms-1 order-1 float-end" id="signBtn"
                [disabled]="disableSignButton()" (click)="startSignflow();" translate="Button.SignNow"></button>
        </span>
    </div>
</div>